// extracted by mini-css-extract-plugin
module.exports = {"wincalc-control-wrapper":"sizes_wincalc-control-wrapper__3aX_Y","wincalc-size":"sizes_wincalc-size__39HwV","form-control":"sizes_form-control__3v6Oy"};